import { Component, Input, EventEmitter, Output } from '@angular/core';

import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { Platform, ActionSheetController, ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

import { UtilsService } from '@shared/providers/utils.service';

import { ImageEditModalComponent } from './../modals/image-edit-modal/image-edit-modal.component';

@Component({
  selector: 'app-profile-photo-circle',
  templateUrl: './profile-photo-circle.component.html',
  styleUrls: ['./profile-photo-circle.component.scss'],
})
export class ProfilePhotoCircleComponent {
  @Input() photoUrl;
  @Input() iconName: string;
  @Input() showIcon: boolean;
  @Input() srcIcon: string;
  @Input() fileTypes = 'image/*';
  @Input() fileMaxSizeInBytes = 2000000;
  @Input() defaultPhoto = 'assets/svg/avatar-white.svg';
  @Output() photoUploaded: EventEmitter<any> = new EventEmitter<any>();

  public fileData: File = null;

  constructor(
    private utils: UtilsService,
    private platform: Platform,
    private actionSheetController: ActionSheetController,
    private camera: Camera,
    private modalController: ModalController,
    private translate: TranslateService
  ) {}

  public options: CameraOptions = {
    quality: 70,
    destinationType: this.camera.DestinationType.DATA_URL,
    encodingType: this.camera.EncodingType.JPEG,
    mediaType: this.camera.MediaType.PICTURE,
    targetWidth: 640,
  };

  fileProgress(fileInput: any) {
    this.fileData = fileInput.target.files[0] as File;
    this.preview();
  }

  preview() {
    // Show preview
    if (!this.fileData) {
      return;
    }

    const fileSize = this.fileData.size;
    if (this.fileMaxSizeInBytes < fileSize) {
      this.utils.showToast(
        `${this.translate.instant('COMPONENTS.MAXIMUM_SIZE_EXCEEDED')}`,
        `${this.translate.instant('COMPONENTS.THE_MAXIMUM_UPLOAD')} ${this.fileMaxSizeInBytes / 1000000}MB`
      );
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(this.fileData);
    // tslint:disable-next-line: variable-name
    reader.onload = _event => {
      this.photoUrl = reader.result;
      this.openModalEdit();
      this.photoUploaded.emit(this.photoUrl);
    };
  }

  async openFile() {
    if (this.platform.is('cordova')) {
      const actionSheet = await this.actionSheetController.create({
        buttons: [
          {
            text: `${this.translate.instant('COMPONENTS.CAMERA')}`,
            cssClass: 'text-primary-dark',
            handler: () => {
              this.useCamera();
            },
          },
          {
            text: `${this.translate.instant('COMPONENTS.GALLERY')}`,
            cssClass: 'text-primary-dark',
            handler: () => {
              document.getElementById('fileInput').click();
            },
          },
        ],
      });
      await actionSheet.present();
    } else {
      document.getElementById('fileInput').click();
    }
  }

  async useCamera() {
    const imageData = await this.camera.getPicture(this.options).catch(err => console.error(err));
    this.photoUrl = `data:image/jpeg;base64,${imageData}`;
    this.openModalEdit();
    this.photoUploaded.emit(this.photoUrl);
  }

  openModalEdit() {
    this.modalController
      .create({
        component: ImageEditModalComponent,
        componentProps: {
          image: this.photoUrl,
        },
        cssClass: 'gallery',
      })
      .then(async modal => {
        modal.present();
        const modalData: any = await modal.onWillDismiss();
        if (modalData.data && modalData.data.image) {
          this.photoUrl = modalData.data.image;
          this.photoUploaded.emit(this.photoUrl);
        }
      });
  }
}
